export const SendIcon = (
  <svg className="size-5" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.2501 7.90001L19.8626 4.36251C24.6251 2.77501 27.2126 5.37501 25.6376 10.1375L22.1001 20.75C19.7251 27.8875 15.8251 27.8875 13.4501 20.75L12.4001 17.6L9.2501 16.55C2.1126 14.175 2.1126 10.2875 9.2501 7.90001Z"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6377 17.0625L17.1127 12.575"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
